import { render, staticRenderFns } from "./ProfileProgressDialog.vue?vue&type=template&id=7abe6e4a&"
import script from "./ProfileProgressDialog.vue?vue&type=script&lang=js&"
export * from "./ProfileProgressDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ProfileProgress: require('/home/forge/portal.gradlinc.co.za/releases/20260824084656/components/profile/ProfileProgress.vue').default,ButtonPrimary: require('/home/forge/portal.gradlinc.co.za/releases/20260824084656/components/buttons/ButtonPrimary.vue').default,Modal: require('/home/forge/portal.gradlinc.co.za/releases/20260824084656/components/global/Modal.vue').default})
